import { GtmService as gtm } from 'tradera/services/google-tagmanager-service';

import { logger } from 'packages/logger';

export const trackAttributeSuggestions = (
    draftSelectedAttributes,
    suggestedAttributes,
    suggestionEngine,
    isNewDraft,
    publishedId
) => {
    const comparer = (a, b) => a.localeCompare(b);
    try {
        draftSelectedAttributes.forEach((attribute) => {
            const label = [
                suggestionEngine,
                attribute.id,
                attribute.backingField,
                attribute.values?.sort(comparer).join(','),
                suggestedAttributes
                    .find((sa) => sa.id === attribute.id)
                    ?.values?.sort(comparer)
                    .join(','),
                0,
                !!isNewDraft,
                publishedId
            ];
            gtm.trackAction(
                'MachineLearning',
                'SyiAttributeSuggestion',
                label.join(';')
            );
        });
    } catch (error) {
        logger(error);
    }
};

export const trackShippingRecommendations = (
    draftCategoryId,
    draftShippingOptions,
    recommendedWeight,
    shippingRecommendations,
    publishedId
) => {
    if (shippingRecommendations) {
        try {
            const selectedShippingWeight = draftShippingOptions[0].weight;
            const firstSelectedShippingOption = `${draftShippingOptions[0].productId};${draftShippingOptions[0].providerId}`;
            const secondSelectedShippingOption =
                draftShippingOptions.length == 2
                    ? `${draftShippingOptions[1].productId};${draftShippingOptions[1].providerId}`
                    : ';';
            const recommendedShippingOptionForRecommendedWeight =
                shippingRecommendations.find((sr) => {
                    return sr.weight === recommendedWeight;
                });
            const recommendedShippingOptionForSelectedWeight =
                shippingRecommendations.find((sr) => {
                    return sr.weight === selectedShippingWeight;
                });

            // Expected label
            // categoryId;recommendedWeight;recommendedProductIdForRecommendedWeight;recommendedProviderForRecommendedWeight;recommendedProductIdForSelectedWeight;recommendedProviderForSelectedWeight;selectedWeight;selectedProductIdFirst;selectedProviderIdFirst;selectedProductIdSecond;selectedProviderIdSecond;completionTimeInSeconds
            const label = [
                draftCategoryId,
                recommendedWeight,
                recommendedShippingOptionForRecommendedWeight
                    ? recommendedShippingOptionForRecommendedWeight.shippingProductId
                    : '',
                recommendedShippingOptionForRecommendedWeight
                    ? recommendedShippingOptionForRecommendedWeight.shippingProvider
                    : '',
                recommendedShippingOptionForSelectedWeight
                    ? recommendedShippingOptionForSelectedWeight.shippingProductId
                    : '',
                recommendedShippingOptionForSelectedWeight
                    ? recommendedShippingOptionForSelectedWeight.shippingProvider
                    : '',
                selectedShippingWeight,
                firstSelectedShippingOption,
                secondSelectedShippingOption,
                0,
                publishedId
            ];
            gtm.trackAction(
                'MachineLearning',
                'SyiShippingRecommendations',
                label.join(';')
            );
        } catch (error) {
            logger(error);
        }
    }
};
